import React from "react";
import "./FooterSection.css";

const FooterSection = () => {
  return (
    <footer className="footer-container">
      <div className="footer-inner">
        <h4>2025 &copy; All rights reserved by Zenito Ventures</h4>
      </div>
    </footer>
  );
};

export default FooterSection;
